module.exports = __webpack_public_path__ + "static/media/BlackPaw.042904c2.svg";